<template>
	<div
		:class="rootClasses"
		:style="minimize_ad ? minimizedOuterStyle : null"
	>
		<div class="pro-features__texture" aria-hidden="true"></div>
		<div class="pro-features__vignette" aria-hidden="true"></div>

		<button
			type="button"
			class="post-smtp-minimize-ad"
			:aria-expanded="(!minimize_ad).toString()"
			:aria-label="minimizeAriaLabel"
			@click="minimizeAd"
		>
			<span
				class="dashicons"
				:class="minimize_ad ? 'dashicons-arrow-down-alt2' : 'dashicons-arrow-up-alt2'"
			></span>
		</button>

		<div class="container" :class="{ 'container--minimized': minimize_ad }">
			<header class="header">
				<div class="header__brand">
					<post-smtp-img
						class="header__hero"
						:src="plugin_dir_url + 'assets/images/pro-feature-svg-icon.svg'"
						:alt="headerHeroAlt"
					/>
				</div>
			</header>

			<transition name="fade" enter-active-class="animated slideIn">
				<div v-if="!minimize_ad" class="body" style="border:none;gap: 0px 1%;">
					<div class="body__integrations" role="list">
						<div
							v-for="( item, index ) in integrationList"
							:key="item.img || index"
							class="integration-tile"
							role="listitem"
						>
							<post-smtp-img
								class="integration-tile__art"
								:src="plugin_dir_url + 'assets/images/' + item.img"
								:alt="integrationAltText( item )"
							/>
						</div>
					</div>

					<div class="body__divider" aria-hidden="true"></div>

					<div class="body__highlights" role="list" style="padding-left: 60px; border:none">
						<div
							v-for="item in highlightList"
							:key="item.title"
							class="highlight-tile"
							role="listitem"
						>
							<!-- <div class="highlight-tile__circle" aria-hidden="true"> -->
								<post-smtp-img
									class="highlight-tile__icon"
									:src="plugin_dir_url + 'assets/images/' + item.img"
								/>
							<!-- </div> -->
							<div class="highlight-tile__text">
								<p v-html="addLineBreak(item.title)"></p>
							</div>
						</div>
					</div>
				</div>
			</transition>

			<transition name="fade" enter-active-class="animated slideIn">
				<div v-if="!minimize_ad" class="footer">
					<post-smtp-button
						type="get-pro"
						:href="click_link"
						target="_blank"
					>
						{{ i18n.button }}&nbsp;→
					</post-smtp-button>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	name: 'postSmtpProFeatures',

	props: {
		postSmtpAdPosition: {
			type: String,
			default: 'maximize',
		},
	},

	data: ( vm ) => ( {
		i18n: postSmtpNewDashboard.i18n.proFeatures,
		plugin_dir_url: vm.$parent.plugin_dir_url,
		is_bcfm: postSmtpNewDashboard.is_bfcm,
		click_link: '',

		minimize_ad: 'minimize' === vm.postSmtpAdPosition,
	} ),

	computed: {
		rootClasses() {
			return {
				bcfm: this.is_bcfm,
				'pro-features': true,
				'pro-features--minimized': this.minimize_ad,
			};
		},
		minimizedOuterStyle() {
			return { minHeight: '88px', height: 'auto' };
		},
		minimizeAriaLabel() {
			const e = this.i18n.expandBanner;
			const c = this.i18n.collapseBanner;
			return this.minimize_ad
				? ( typeof e === 'string' && e ? e : 'Expand Pro features banner' )
				: ( typeof c === 'string' && c ? c : 'Collapse Pro features banner' );
		},

		headerHeroAlt() {
			const t = this.i18n.title;
			const d = this.i18n.description;
			const title = typeof t === 'string' ? t.trim() : '';
			const desc = typeof d === 'string' ? d.trim() : '';
			if ( title && desc ) {
				return `${ title }. ${ desc }`;
			}
			return title || desc || 'Pro features';
		},
		integrationList() {
			const list = this.i18n.integrationList;
			if ( Array.isArray( list ) && list.length ) {
				return list;
			}
			return [
				{ img: 'office-pro-feature.svg', label: 'Microsoft 365' },
				{ img: 'aws-pro-feature.svg', label: 'Amazon SES' },
				{ img: 'gmail-pro-feature.svg', label: 'Gmail' },
				{ img: 'zoho-pro-feature.svg', label: 'Zoho Mail' },
			];
		},
		highlightList() {
			const list = this.i18n.highlightList;
			if ( Array.isArray( list ) && list.length ) {
				return list;
			}
			return [
				{ title: postSmtpNewDashboard.i18n.proFeatures.list[0], img: 'pro-schedule-icon.svg' },
				{ title: postSmtpNewDashboard.i18n.proFeatures.list[3], img: 'pro-sms-icon.svg' },
				{ title: postSmtpNewDashboard.i18n.proFeatures.list[2], img: 'pro-log-icon.svg' },
				{ title: postSmtpNewDashboard.i18n.proFeatures.list[1], img: 'pro-reporting-icon.svg' },
			];
		},
	},

	methods: {
		integrationAltText( item ) {
			if ( ! item || typeof item !== 'object' ) {
				return '';
			}
			if ( typeof item.label === 'string' && item.label.trim() ) {
				return item.label.trim();
			}
			if ( typeof item.name === 'string' && item.name.trim() ) {
				return item.name.replace( /\r\n/g, ' ' ).trim();
			}
			return '';
		},

		addLineBreak( text ) {
			return String( text ).replace( /\r\n/g, '<br>' );
		},

		minimizeAd() {
			this.minimize_ad = ! this.minimize_ad;
			const minimize_maximize = this.minimize_ad ? 'minimize' : 'maximize';

			axios.post( 'minimize-maximize-ad', {
				minimize_maximize,
			} )
				.then( () => {} );
		},
	},

	mounted() {
		this.is_bcfm = '1' === this.is_bcfm;

		this.click_link = this.is_bcfm ? 'https://postmansmtp.com/cyber-monday-sale?utm_source=plugin&utm_medium=section_name&utm_campaign=BFCM&utm_id=BFCM_2024' : 'https://postmansmtp.com/pricing/?utm_source=plugin&utm_medium=dashboard_pro_banner&utm_campaign=plugin';
	},
};
</script>

<style scoped>
.pro-features * {
	box-sizing: border-box;
}

.pro-features {
	--pro-banner-bg-a: #2b6399;
	--pro-banner-bg-b: #214a72;
	--pro-banner-gold-1: #fff4d9;
	--pro-banner-gold-2: #f9d78a;
	--pro-banner-gold-3: #f5a84a;
	--pro-banner-gold-4: #e87828;
	--pro-banner-text: #f3f6ff;

	position: relative;
	overflow: hidden;
	min-height: 380px;
	height: auto;
	border-radius: 16px;
	background: linear-gradient(
		168deg,
		var(--pro-banner-bg-a) 0%,
		var(--pro-banner-bg-b) 100%
	);
	box-shadow:
		0 4px 6px rgba(6, 20, 40, 0.12),
		0 18px 40px rgba(8, 28, 52, 0.28);
}

.pro-features__texture {
	position: absolute;
	inset: 0;
	border-radius: inherit;
	pointer-events: none;
	z-index: 0;
	background-image: url( '../images/pro-banner-envelope-pattern.svg' );
	background-repeat: repeat;
	background-size: 120px 120px;
	opacity: 0.55;
}

.pro-features__vignette {
	position: absolute;
	inset: 0;
	border-radius: inherit;
	pointer-events: none;
	z-index: 1;
	background: radial-gradient(
		ellipse 75% 60% at 50% 30%,
		rgba(255, 255, 255, 0.06) 0%,
		transparent 55%
	);
	box-shadow: inset 0 0 70px rgba(0, 12, 28, 0.28);
}

.pro-features--minimized .pro-features__texture {
	opacity: 0.4;
}

.pro-features--minimized {
	min-height: 88px;
}

.container {
	position: relative;
	z-index: 2;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	padding: 32px 40px 28px;
	gap: 24px;
}

.container--minimized {
	padding: 20px 56px 20px 28px;
	gap: 0;
}

.header {
	width: 100%;
	margin: 0;
	display: flex;
	justify-content: center;
}

.header__brand {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	width: 100%;
}

.pro-features--minimized .header__brand {
	justify-content: flex-start;
}

/* Replaces crown + “Pro Features” + tagline (pro-feature-svg-icon.svg) */
.header__hero {
	display: block;
	width: min(100%, 380px);
	max-width: 100%;
	height: auto;
	filter: drop-shadow(0 2px 10px rgba(0, 0, 0, 0.2));
}

.pro-features--minimized .header__hero {
	width: auto;
	max-width: min(280px, 78vw);
	max-height: 44px;
	object-fit: contain;
	object-position: left center;
}

.body {
	display: flex;
	flex-direction: column;
	align-items: stretch;
	width: 100%;
	margin: 0;
	padding: 20px 0 16px;
	gap: 0;
	border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.body__integrations {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	align-content: center;
	gap: 20px 2%;
	width: 100%;
}

/* Full SVG art includes service name — no separate title under the image */
.integration-tile {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	text-align: center;
	flex: 1 1 0;
	min-width: 0;
	width: auto;
	max-width: 220px;
}

/* Same box width for every integration SVG (Gmail matches Office/AWS/Zoho) */
.integration-tile__art {
	display: block;
	width: 300px;
	max-width: 100%;
	height: auto;
	max-height: 80px;
	margin: 0 auto;
	object-fit: contain;
	object-position: center;
}

.body__divider {
	width: 100%;
	height: 5px;
	margin: 20px 0;
	background: linear-gradient(
		90deg,
		transparent 0%,
		rgba(255, 255, 255, 0.2) 20%,
		rgba(255, 255, 255, 0.2) 80%,
		transparent 100%
	);
}

/* Equal padding above & below the icon+text row (between divider and bottom rule) */
.body__highlights {
	display: flex;
	flex-wrap: nowrap;
	justify-content: space-evenly;
	align-items: center;
	gap: 10px 12px;
	width: 100%;
	padding: 18px 0;
	border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.highlight-tile {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	flex: 1 1 0;
	min-width: 0;
	width: auto;
	max-width: none;
	gap: 5px;
	margin: 0;
}

.highlight-tile__circle {
	flex-shrink: 0;
	width: 48px;
	height: 48px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	background: rgba(255, 255, 255, 0.1);
	border: 1px solid rgba(255, 255, 255, 0.22);
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.highlight-tile__icon {
	max-height: 40px;
	width: auto;
	height: auto;
	object-fit: contain;
}

.highlight-tile__text {
	margin: 0;
	flex: 1 1 auto;
	min-width: 0;
	max-width: 12rem;
}

.highlight-tile__text :deep(p) {
	margin: 0;
	padding: 0;
	font-family: Poppins, system-ui, sans-serif;
	font-size: 14px;
	font-weight: 500;
	line-height: 1.35;
	text-align: left;
	color: var(--pro-banner-text);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.footer {
	margin: 2px 0 0;
	width: 100%;
	display: flex;
	justify-content: center;
}

.footer :deep(.btn-get-pro) {
	background: linear-gradient(
		90deg,
		#fff0dc 0%,
		#ffd89a 28%,
		#f9b24d 62%,
		#ff8f3c 100%
	) !important;
	color: #1a1a1a !important;
	font-weight: 700 !important;
	padding: 14px 40px !important;
	box-shadow:
		0 4px 20px rgba(248, 140, 50, 0.45),
		0 1px 0 rgba(255, 255, 255, 0.5) inset;
	border: 1px solid rgba(255, 255, 255, 0.4);
	transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.footer :deep(.btn-get-pro:hover) {
	transform: translateY(-2px);
	box-shadow:
		0 8px 28px rgba(248, 140, 50, 0.5),
		0 1px 0 rgba(255, 255, 255, 0.55) inset;
}

.post-smtp-minimize-ad {
	position: absolute;
	top: 16px;
	right: 18px;
	z-index: 3;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	padding: 0;
	margin: 0;
	border: 1px solid rgba(255, 255, 255, 0.45);
	border-radius: 8px;
	background: rgba(255, 255, 255, 0.06);
	color: #fff;
	cursor: pointer;
	transition: background 0.15s ease, border-color 0.15s ease;
}

.post-smtp-minimize-ad:hover {
	background: rgba(255, 255, 255, 0.14);
	border-color: rgba(255, 255, 255, 0.65);
	color: #fff;
}

.post-smtp-minimize-ad:focus {
	outline: 2px solid rgba(255, 255, 255, 0.6);
	outline-offset: 2px;
}

.post-smtp-minimize-ad .dashicons {
	font-size: 18px;
	width: 18px;
	height: 18px;
	line-height: 18px;
}

.bcfm {
	background-image:
		url( '../images/bfcm-2024/dashboard-banner-strip.png' ),
		linear-gradient(
			168deg,
			var(--pro-banner-bg-a) 0%,
			var(--pro-banner-bg-b) 100%
		);
	background-repeat: no-repeat, no-repeat;
	background-size: auto, auto;
	background-position: top right, center;
}

@media only screen and (max-width: 1200px) {
	.integration-tile {
		flex: 1 1 calc(50% - 12px);
		max-width: min(240px, 48%);
		min-width: 120px;
	}

	.body__highlights {
		gap: 8px 8px;
	}

	.highlight-tile {
		flex: 1 1 0;
		min-width: 0;
		gap: 6px;
	}

	.highlight-tile__circle {
		width: 44px;
		height: 44px;
	}

	.highlight-tile__text :deep(p) {
		font-size: 11px;
	}
}

@media only screen and (max-width: 640px) {
	.container {
		padding: 28px 20px 24px;
	}

	.body__integrations {
		gap: 22px 5%;
	}

	.integration-tile {
		flex: 1 1 calc(50% - 10px);
		max-width: min(220px, 48%);
		min-width: 110px;
	}

	.integration-tile__art {
		width: 160px;
		max-height: 62px;
	}

	/* Keep four highlights on one row; scroll if the viewport is too narrow */
	.body__highlights {
		flex-wrap: nowrap;
		justify-content: flex-start;
		align-items: center;
		overflow-x: auto;
		overflow-y: hidden;
		gap: 12px;
		padding: 16px 0;
		-webkit-overflow-scrolling: touch;
		scrollbar-width: thin;
	}

	.highlight-tile {
		flex: 0 0 auto;
		flex-direction: row;
		align-items: center;
		min-width: 0;
		width: auto;
		max-width: none;
	}

	.highlight-tile__text {
		max-width: 9rem;
	}

	.highlight-tile__text :deep(p) {
		text-align: left;
		white-space: nowrap;
	}
}
</style>
